import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { EventsService } from '../../../events.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pubg-lite',
  templateUrl: './pubg-lite.component.html',
  styleUrls: ['./pubg-lite.component.css']
})
export class PubgLiteComponent implements OnInit {

  gameName = "pubg-lite";

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }
}
